var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { PlusBadge2 } from '@lux/plus-badge';
import { Translate, TranslateScope } from '@pegasus/translation';
export var PlusEarlyAccessBadge = function (props) {
    return (React.createElement(TranslateScope, { path: "plus" },
        React.createElement(PlusBadge2, __assign({}, props),
            React.createElement(Translate, { message: "plusEarlyAccess", raw: true }))));
};
